import type { FC, MouseEventHandler } from 'react';
import React, { useState } from 'react';
import SubscribeProduct from '@components/SubscribeProduct';
import { Picture, Modal } from '@ui';
import icons from '@icons';
import useWindowSize from '@customHooks/useWindowSize';
import './index.scss';
import { observer } from 'mobx-react';
import AnalogsModal from '@components/Modals/AnalogsModal';
const {
  email: { white: emailOutlinedWhite }
} = icons.Outline;

interface ProductBuyBtnSubscribeProps {
  isDisabledPopup?: boolean;
  isShowAnalogs?: boolean;
  productId: number;
  callback: any;
}

const ProductBuyBtnSubscribe: FC<ProductBuyBtnSubscribeProps> = observer(
  ({ productId, isDisabledPopup = false, isShowAnalogs = true }) => {
    const { isMobile } = useWindowSize();
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [isAnalogsPopupOpened, setIsAnalogsPopupOpened] = useState(false);
    const openAnalogsPopup: MouseEventHandler = (e): void => {
      e.stopPropagation();
      e.preventDefault();
      setIsAnalogsPopupOpened(true);
    };
    const closeAnalogsPopup = (): void => {
      setIsAnalogsPopupOpened(false);
    };
    return (
      <>
        {!isDisabledPopup && isPopupOpened && (
          <Modal
            open={isPopupOpened}
            className='pop-subscribe'
            withoutCross
            onClose={() => {
              setIsPopupOpened(false);
            }}
          >
            {(close: () => void) => (
              <SubscribeProduct
                productId={productId}
                isModal
                desktopPopup={!isMobile}
                centeredModal={isMobile}
                closeModal={() => {
                  close();
                  setIsPopupOpened(false);
                }}
                subscriptionType='in_stock'
              />
            )}
          </Modal>
        )}
        {isAnalogsPopupOpened && (
          <AnalogsModal
            catalogId={productId}
            onCloseModal={closeAnalogsPopup}
          />
        )}
        <div className='flex items-center justify-between w-full h-10 text-center allMd:h-8'>
          {isShowAnalogs && (
            <div
              className='w-full h-full mr-2 bg-[var(--mid-yellow)] rounded-lg text-sm flex items-center justify-center transition-colors hover:bg-[var(--gold-light)]'
              onClick={openAnalogsPopup}
            >
              Похожие
            </div>
          )}
          <div
            className='product-card-subscribe-btn'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              setIsPopupOpened(true);
            }}
          >
            <Picture icon={emailOutlinedWhite} height='24' width='24' />
          </div>
        </div>
      </>
    );
  }
);

export default ProductBuyBtnSubscribe;
